module.exports = __webpack_public_path__ + "img/8.844f14f1.png";